<template>
  <div class="page-container">
    <AppSidebar />

    <div class="main-content">
      <div class="static-page">
        <div class="page-header">
          <h1>网站声明</h1>
        </div>

        <div class="content-container">
          <div class="content-text">
            <h2>一、版权声明</h2>
            <p>本网站所有内容，包括但不限于文字、图片、音频、视频、软件、程序、版面设计等，均受《中华人民共和国著作权法》及相关法律法规的保护。</p>
            <ul>
              <li>本网站内容的版权归武汉天冉网络科技有限公司及原作者所有</li>
              <li>未经书面许可，任何单位和个人不得擅自复制、转载、使用本网站内容</li>
              <li>违反上述声明者，本网站将依法追究其法律责任</li>
            </ul>

            <h2>二、内容免责</h2>
            <p>本网站力求为用户提供准确、完整的信息，但不对以下情况承担责任：</p>
            <ul>
              <li>因技术故障、网络传输等原因导致的信息错误或遗漏</li>
              <li>用户因使用本网站内容而产生的任何直接或间接损失</li>
              <li>第三方链接内容的准确性和完整性</li>
              <li>因不可抗力因素导致的服务中断或数据丢失</li>
            </ul>

            <h2>三、用户行为规范</h2>
            <p>用户在使用本网站时，应遵守以下规范：</p>
            <ul>
              <li>遵守中华人民共和国相关法律法规</li>
              <li>不得发布违法、虚假、侵权、暴力、色情等不良信息</li>
              <li>不得利用本网站从事违法犯罪活动</li>
              <li>不得恶意攻击网站或干扰网站正常运营</li>
              <li>不得侵犯他人合法权益</li>
            </ul>

            <h2>四、知识产权保护</h2>
            <p>我们尊重他人的知识产权，也请用户尊重本网站及权利人的知识产权：</p>
            <ul>
              <li>如发现本网站内容侵犯您的合法权益，请及时联系我们</li>
              <li>我们将在核实后依法处理相关侵权内容</li>
              <li>用户上传的内容应确保拥有合法授权</li>
              <li>用户对其上传内容的合法性负责</li>
            </ul>

            <h2>五、外部链接</h2>
            <p>本网站可能包含指向第三方网站的链接：</p>
            <ul>
              <li>这些链接仅为方便用户而提供</li>
              <li>本网站不对第三方网站的内容负责</li>
              <li>访问第三方网站的风险由用户自行承担</li>
              <li>第三方网站的隐私政策和使用条款以其自身规定为准</li>
            </ul>

            <h2>六、服务变更与终止</h2>
            <p>本网站保留以下权利：</p>
            <ul>
              <li>根据业务需要随时修改、暂停或终止部分或全部服务</li>
              <li>对违反本声明的用户采取警告、限制、封禁等措施</li>
              <li>在法律允许的范围内修改本声明</li>
              <li>对用户上传的违规内容进行删除或屏蔽</li>
            </ul>

            <h2>七、争议解决</h2>
            <p>本声明的解释、效力及纠纷解决：</p>
            <ul>
              <li>本声明适用中华人民共和国法律（不包括冲突法）</li>
              <li>因本声明引起的争议，双方应友好协商解决</li>
              <li>协商不成的，任何一方可向武汉天冉网络科技有限公司所在地人民法院提起诉讼</li>
            </ul>

            <h2>八、联系方式</h2>
            <p>如对本声明有任何疑问，或发现侵权内容，请通过以下方式联系我们：</p>
            <ul>
              <li>公司名称：武汉天冉网络科技有限公司</li>
              <li>联系电话：13641239621</li>
              <li>电子邮箱：wudongjian@huashi.tv</li>
              <li>公司地址：湖北省武汉市洪山区雄楚大街452号保利蓝海郡G6栋1单元20层3室-2</li>
            </ul>

            <p class="update-time">最后更新时间：2026年6月12日</p>
          </div>
        </div>
      </div>

      <AppFooter />
    </div>
  </div>
</template>

<script>
import AppSidebar from '@/components/layout/Sidebar.vue';
import AppFooter from '@/components/layout/Footer.vue';

export default {
  name: 'StatementPage',
  components: {
    AppSidebar,
    AppFooter
  },
  mounted() {
    document.title = '网站声明 - 武汉天冉网络科技有限公司';
  }
};
</script>

<style scoped>
.page-container {
  display: flex;
  min-height: 100vh;
  background-color: #f5f6fa;
}

.main-content {
  flex: 1;
  margin-left: 200px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.static-page {
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
  flex: 1;
  width: 100%;
}

.page-header {
  text-align: center;
  margin-bottom: 40px;
}

.page-header h1 {
  font-size: 30px;
  color: #333;
  margin-bottom: 10px;
  font-weight: 600;
  position: relative;
  display: inline-block;
  padding-bottom: 15px;
}

.page-header h1:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #ff6b81, #ff9eb6);
  border-radius: 3px;
}

.content-container {
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.08);
}

.content-text {
  line-height: 1.8;
  color: #444;
  font-size: 16px;
}

.content-text h2 {
  font-size: 22px;
  margin: 25px 0 15px;
  color: #333;
}

.content-text p {
  margin-bottom: 15px;
}

.content-text ul {
  margin-bottom: 15px;
  padding-left: 20px;
}

.content-text li {
  margin-bottom: 8px;
}

.update-time {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;
  color: #999;
  font-size: 14px;
  text-align: center;
}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
  }

  .static-page {
    padding: 20px 15px;
  }

  .content-container {
    padding: 20px;
  }
}
</style>
